export default "__VITE_ASSET__CbH3sG8C__"